import { render, staticRenderFns } from "./PurchaseIndex.vue?vue&type=template&id=9d588756&scoped=true"
import script from "./PurchaseIndex.vue?vue&type=script&lang=js"
export * from "./PurchaseIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d588756",
  null
  
)

export default component.exports